<template>
  <!-- 我的优惠券 -->
  <van-tabs v-model:active="active">
    <!-- 可使用类型优惠券 -->
    <van-tab :title="`可使用（${enablePlanList.length}）`">
      <div class="couponList">
        <div @click="toPromotionCouponList" class="migrationCoupon">
          <van-cell title="单元格" icon="shop-o" is-link>
            <template #icon>
              <img src="../../../assets/images/migrationCoupon.png" alt="" class="migrationImg" />
            </template>
            <template #title> 查看已领取的活动促销优惠券 </template>
          </van-cell>
        </div>
        <template v-for="item in enablePlanList" :key="item.id">
          <couponCard class="couponCard" :datas="item" :isDetail="true" :isMy="true" @click="clickCard(item)"> </couponCard>
        </template>
      </div>
      <Loading v-if="isShowLoad" />
      <!-- <van-divider v-if="!enablePlanList.length && !isShowLoad " dashed :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }">很遗憾，没有找到相关结果 </van-divider> -->
    </van-tab>
    <!-- 不可使用类型优惠券 -->
    <van-tab :title="`不可使用（${disablePlanList.length}）`">
      <div class="couponList">
        <template v-for="item in disablePlanList" :key="item.id">
          <couponCard class="couponCard" :datas="item" :disable="true" :isDetail="true" :isMy="true" @click="clickCard(item)"> </couponCard>
        </template>
      </div>
      <Loading v-if="isShowLoad1" />
      <!-- <van-divider v-if="!disablePlanList.length && !isShowLoad1 " dashed :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }">很遗憾，没有找到相关结果 </van-divider> -->
    </van-tab>
  </van-tabs>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import couponCard from '@/components/couponCollection/CouponCard'
import Loading from '@/components/common/Loading.vue'
import { useRouter } from 'vue-router'
import { getMyCouponList } from '@/api/couponCollection'
import { showToast } from '@/util/couponCollection'
import { linkToPromotion } from '@/util'
import { couponList } from '@/util/plan'

export default {
  components: {
    Loading,
    couponCard
  },
  setup() {
    let router = useRouter()
    const state = reactive({
      active: 0,
      enablePlanList: [],
      disablePlanList: [],
      isShowLoad: false,
      isShowLoad1: false,
      pageSize: 100000
    })
    // 点击优惠券函数
    const clickCard = item => {
      router.push({ path: '/myCouponDetail', query: { couponId: item.id, event: '我的优惠券详情' } })
    }
    // 获取可使用优惠券列表
    const getEnablePlanList = async () => {
      try {
        state.isShowLoad = true
        let { list } = await getMyCouponList({ pageSize: state.pageSize, statusFlag: 1 })
        list = couponList(list)
        state.enablePlanList = list
        state.isShowLoad = false
      } catch (e) {
        state.isShowLoad = false
        showToast(e.message, '请求可用列表数据失败')
      }
    }
    // 获取不可使用优惠券列表
    const getDisablePlanList = async () => {
      try {
        state.isShowLoad1 = true
        let { list } = await getMyCouponList({ pageSize: state.pageSize, statusFlag: 2 })
        list = couponList(list)
        // statusFlag // 权益状态{状态1:未生效 2:可使用 3:已过期 4:暂不可用 5.已使用}
        // 按未生效》已使用〉已过期顺序展示
        let disableList = list.filter(item => item.statusFlag === 1)
        let passList = list.filter(item => item.statusFlag === 3)
        let otherList = list.filter(item => item.statusFlag === 4)
        let usedList = list.filter(item => item.statusFlag === 5)
        state.disablePlanList = [...disableList, ...usedList, ...passList, ...otherList]
        state.isShowLoad1 = false
      } catch (e) {
        state.isShowLoad1 = false
        showToast(e.message, '请求不可用列表数据失败')
      }
    }
    // 跳转到活动促销我的优惠券页面
    const toPromotionCouponList = () => {
      linkToPromotion('my_coupons')
    }
    onMounted(async () => {
      getEnablePlanList()
      getDisablePlanList()
    })
    return {
      ...toRefs(state),
      clickCard,
      toPromotionCouponList
    }
  }
}
</script>

<style lang="scss" scoped>
.van-tabs {
  background: #f5f5f5;
  position: absolute;
  padding-bottom: calc(50px + constant(safe-area-inset-bottom));
  padding-bottom: calc(50px + env(safe-area-inset-bottom));
  overflow: auto;
  box-sizing: border-box;
  :deep(.van-tab--active) {
    color: #3088c5;
  }
  :deep(.van-tabs__line) {
    background: #3088c5;
  }
}
.couponList {
  padding: 16px 20px 30px;
  background: #f5f5f5;
  box-sizing: border-box;
}
.couponCard {
  margin-bottom: 12px;
}
.migrationCoupon {
  height: 40px;
  margin-bottom: 12px;
  line-height: 40px;
  font-size: 14px;
  background: #fff;
  text-align: left;
}
.migrationImg {
  width: 22px;
  height: 16px;
  margin: 4px 8px 4px 0;
}
</style>
